<template>
  <div style="height: 30vh">
      <div class="title" style="height: 10%">D2 Probelm Definition</div>
      <div style="height: 90%;" class="bad-scroll">
        <table class="table-wrapper" style="height:100%">
          <thead>
            <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
              <th style="height:30px">Customer</th>
              <th style="height:30px">Program</th>
              <th style="height:30px">Material/Equipment</th>
              <th style="height:30px">What</th>
              <th style="height:30px">Where</th>
              <th style="height:30px">When</th>
            </tr>
          </thead>
          <tbody>
            <tr style="font-size:13px;">
              <td>{{dataBean['Customer']}}</td>
              <td>{{dataBean['Program']}}</td>
              <td>{{dataBean['Material/Equipment']}}</td>
              <td>{{dataBean['What']}}</td>
              <td>{{dataBean['Where']}}</td>
              <td>{{dataBean['When']}}</td>
            </tr>
            <tr style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
              <td style="height:30px" colspan="2">Found by Whom</td>
              <td style="height:30px" colspan="2">Defect Rate/Quantity</td>
              <td style="height:30px">Repeated Problem</td>
              <td style="height:30px">Impact to</td>
            </tr>
            <tr style="font-size:10px;">
              <td colspan="2">{{dataBean['Found by Whom']}}</td>
              <td colspan="2">{{dataBean['Defect Rate/Quantity']}}</td>
              <td>{{dataBean['Repeated Problem']}}</td>
              <td>{{dataBean['Impact to']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>
export default {
  name: "fr2d",
    props: {
    bean: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  watch: {
    bean: {
      handler: function (val, oldVal) {
        if (val["d2"]) {
          this.dataBean = val["d2"];
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      dataBean:{},
      startCharts: null,
    };
  },
  mounted() {},
  methods: {
    fontSize(res) {
      let docEl = document.documentElement,
        clientWidth =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
      if (!clientWidth) return;
      let fontSize = 100 * (clientWidth / 1920);
      return res * fontSize;
    },
  },
  destroyed() {
    if (this.startCharts) {
      clearInterval(this.startCharts);
    }
  },
};
</script>
<style scoped>
.title {
  width: 100%;
  margin: 0 auto;
  left: 0;
  right: 0;
  font-weight: bold;
  text-align: left;
  font-size: 15px;
  z-index: 1;
  text-shadow: 0 0 5px #fff, 0 0 35px #33ccff, 0 0 45px #33ccff,
    0 0 50px #33ccff;
}

.table-wrapper {
  width: 100%;
  border-collapse: collapse;
  border-top: 1px solid #2c7be8;
  border-right: 1px solid #2c7be8;
}

.table-wrapper > thead > tr > th {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  padding: 4px 0;
  font-size: 12px;
  min-width:50px;
  font-size: 13px;
}

.table-wrapper > tbody > tr > td {
  border-bottom: 1px solid #2c7be8;
  border-left: 1px solid #2c7be8;
  color: white;
  font-weight: bold;
  padding: 4px 0;
  text-align: center;
  font-size: 13px;
}

.bad-scroll{
    overflow-y:auto
}
.bad-scroll::-webkit-scrollbar {
    width: 4px;
    height: 1px;
}

.bad-scroll::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #909090;
}
.bad-scroll::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #EDEDED;
}
</style>


// WEBPACK FOOTER //
// src/pages/fr/8d/component/2d.vue